import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventsTableHeaderStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsMainSectionWrapper';
import {
    TopEventsState,
    TopEventsSportSingleType,
} from 'src/domains/layouts/webview/components/topEvents/TopEventsState.state';
import { TopEventsSportSectionWrapper } from 'src/domains/layouts/webview/components/topEvents/TopEventsSportSectionWrapper';
import { FiltersStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsTable.style';
import { FiltersScrollableWrapper } from 'src/domains/layouts/webview/components/filters/FiltersScrollableWrapper';
import { Filter } from 'src/domains/layouts/webview/components/filters/Filters.style';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { Collapse } from 'src/ui/components/collapse/sports/01/Collapse';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { SectionHeader } from 'src/ui/components/collapse/sports/05/SectionHeader';
import { FiltersSkin } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { TranslationsStore } from 'src/domains/layouts/state/translationsStore/TranslationsStore';

export const TopEvents = observer('TopEvents', () => {
    const common = useCommon();
    const topEventsState = TopEventsState.get(common);
    const {
        componentVariants: { sportsbookVariant, filtersVariant },
        unifiedSportEventsTable,
    } = ConfigComponents.get(common).unifiedComponentConfig;
    const topEventsSports = topEventsState.topEventsSportsToShow;
    const language = LanguagesState.get(common);
    const models = common.models;
    const translationsStore = TranslationsStore.get(common);

    const titleJsx = (
        <UniverseComponent>
            {(universe): React.ReactElement => <span>{universe.topEventsSectionTitle(language)}</span>}
        </UniverseComponent>
    );

    if (topEventsSports.length > 0) {
        return (
            <div>
                {unifiedSportEventsTable ? (
                    <SectionHeader
                        title={titleJsx}
                        dataTest='promoted-event-header'
                    />
                ) : (
                    <Collapse
                        title={titleJsx}
                        isOpen={topEventsState.openEvents}
                        handleToggle={topEventsState.setOpenEvents}
                        dataTest='topEvents-event-header'
                    />
                )}

                {topEventsState.openEvents ? (
                    <>
                        <FiltersStyle
                            headerStyle={EventsTableHeaderStyle.SOLID}
                            isCompetitionPage={false}
                            variant={sportsbookVariant}
                        >
                            <FiltersScrollableWrapper>
                                {topEventsState.sportFiltersAll.map((sport) => {
                                    const sportName =
                                        models.getSport(sport.key)?.name ?? translationsStore.translateSport(sport.key);
                                    return (
                                        <Filter
                                            key={sport.key}
                                            title={sport.key === 'all' ? 'All Sports' : sportName}
                                            disabled={false}
                                            skin={unifiedSportEventsTable ? FiltersSkin.TERTIARY : FiltersSkin.PRIMARY}
                                            onClick={(): void =>
                                                topEventsState.handleToggleIsSportFilterActive(sport.key)
                                            }
                                            isActive={topEventsState.isFilterActive(sport.key)}
                                            data-test={`topEvents-event-filter-${sportName.toLowerCase().replaceAll(' ', '')}`}
                                            variant={unifiedSportEventsTable ? sportsbookVariant : filtersVariant}
                                        >
                                            {sport.key === 'all' ? 'All Sports' : sportName}
                                        </Filter>
                                    );
                                })}
                            </FiltersScrollableWrapper>
                        </FiltersStyle>
                        {topEventsSports.map((sportData: TopEventsSportSingleType) => (
                            <React.Fragment key={sportData.id}>
                                {topEventsState.sportFiltersAll.map((elem) => {
                                    if (elem.key === sportData.sport_id && sportData.competitions_list.length > 0) {
                                        return (
                                            <TopEventsSportSectionWrapper
                                                key={sportData.id}
                                                sportSlug={sportData.sport_id}
                                                topEventsState={topEventsState}
                                                sportData={sportData}
                                            />
                                        );
                                    }
                                })}
                            </React.Fragment>
                        ))}{' '}
                    </>
                ) : null}
            </div>
        );
    }

    return null;
});
